import { Dialog, EntityForm } from '@lbcamden/lib-react';
import { FunctionComponent, useMemo } from 'react';

import {
  useProperty,
  useReferenceListSelectOptions,
  useTenantList,
  useUserStore,
} from '~/client/hooks/storeHooks';
import { propertyAttributesUpdateSchema } from '~/common/schemas/buildings';
import { PropertyDetails, PropertyDetailsUpdate } from '~/common/types/buildings';

import { propertyDetailsFormConfig, sanitiseUpdate } from './config';

type Props = {
  open?: boolean;
  propertyDetails: PropertyDetails;
  onClose(): void;
};

const title = 'Edit property attributes';

export const PropertyAttributesEditDialog: FunctionComponent<Props> = ({
  open,
  propertyDetails,
  onClose,
}) => {
  const userStore = useUserStore();
  const { propertyRef = '' } = useProperty(propertyDetails.propertyId) || {};
  const tenantList = useTenantList(propertyDetails.propertyId);
  const refListSelectOptions = useReferenceListSelectOptions();

  const { tenancyId } = tenantList[0] || {};

  const formConfig = useMemo(
    () => propertyDetailsFormConfig(refListSelectOptions),
    [refListSelectOptions],
  );

  const onSave = (update: PropertyDetailsUpdate) => {
    userStore?.handleAndDispatchMessage(
      'updatePropertyAttributes',
      propertyDetails.propertyId,
      sanitiseUpdate(propertyDetails, update),
    );
    onClose();
  };

  return (
    <Dialog open={open} title={title} accessibleInfo={{ title }} onClose={onClose}>
      <EntityForm
        inDialog
        schema={propertyAttributesUpdateSchema}
        config={formConfig}
        initialValue={{ propertyRef, tenancyId, ...propertyDetails }}
        onCancel={onClose}
        onSave={onSave}
      />
    </Dialog>
  );
};
